import { useParameterStore } from "@/frontend/store/ParameterStore";
import { ParameterType, ParameterSubjectType } from "@/types/parameterTypes";
import { useShallow } from "zustand/react/shallow";
import { ParameterItem } from "./ParameterItem";
import { ParameterAddButton } from "./ParameterAddButton";

export function ParameterTable(props: { subjectId: string, parameterType: ParameterType, subjectType: ParameterSubjectType, hideAddButton?: boolean }) {
    const { subjectId, parameterType, subjectType, hideAddButton } = props;
    const parameters = useParameterStore(useShallow(state => state.parametersForSubjectAndType(subjectId, parameterType)));

  return (
    <div>
      {parameters.map((parameter) => <ParameterItem key={parameter.id} parameter={parameter} />) }
      {!hideAddButton && <ParameterAddButton subjectId={subjectId} parameterType={parameterType} subjectType={subjectType} />}
    </div>
  );
}